import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { environment } from 'src/environments/environment';

/**
 * Prefixa "Teste - " no título da aba no ambiente de teste, pra distinguir
 * visualmente da produção quando várias abas estão abertas. Estende a
 * `TitleStrategy` do Router (em vez de mexer no `title` de cada rota) porque
 * quase toda rota já define seu próprio título — este strategy intercepta
 * todos eles num só lugar.
 */
@Injectable({ providedIn: 'root' })
export class TesteAwareTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const routeTitle = this.buildTitle(snapshot);
    if (routeTitle === undefined) return;

    const prefix = environment.env === 'teste' ? 'Teste - ' : '';
    this.title.setTitle(prefix + routeTitle);
  }
}
